export default "__VITE_ASSET__C4yTep0v__"